import IconButton from 'components/IconButton';
import NoRecordFound from 'components/NoRecordFound/NoRecordFound';
import { useAtomValue, useSetAtom } from 'jotai';
import { showFailureToast, showSuccessToast } from 'lib/ToastHelper';
import React from 'react';
import { companyIdAtom } from 'views/state';

import {
  getProductSubscription,
  subscribeProduct,
  unsubscribe,
} from './helper';
import {
  productsDataAtom,
  productSubscriptionsAtom,
  refreshSubscriptionsAtom,
  selectedVendorAtom,
} from '../state';

const ProductsListing: React.FC = () => {
  const productsData = useAtomValue(productsDataAtom);
  const products = productsData?.results;
  const productSubscriptions = useAtomValue(productSubscriptionsAtom);
  const selectedVendor = useAtomValue(selectedVendorAtom);
  const setRefreshSubscription = useSetAtom(refreshSubscriptionsAtom);
  const companyId = useAtomValue(companyIdAtom);

  const handleSubscribe = (vendorName, productName) => {
    subscribeProduct(vendorName, productName, companyId)
      .then((result) => {
        if (result === true) {
          showSuccessToast('Subscription Successful');
          setRefreshSubscription(Math.random()); // Reset atom only if subscription is successful
        } else {
          showFailureToast('Failed to subscribe');
        }
      })
      .catch((_error) => {
        showFailureToast('Failed to subscribe');
      });
  };

  const handleUnsubscribe = (id) => {
    unsubscribe(id, companyId)
      .then((result) => {
        if (result === true) {
          showSuccessToast('Successfully unsubscribed');
          setRefreshSubscription(Math.random()); // Reset atom only if operation is successful
        } else {
          showFailureToast('Failed to unsubscribe');
        }
      })
      .catch((_error) => {
        showFailureToast('Failed to unsubscribe');
      });
  };

  return (
    <>
      {products && products?.length > 0 ? (
        products.map((product) => {
          let subscription = getProductSubscription(
            productSubscriptions,
            selectedVendor,
            product.name,
          );

          return (
            <tr key={product.name}>
              <td>{product.name}</td>
              <td>{selectedVendor}</td>
              <td className="text-right">
                {subscription !== undefined ? (
                  <IconButton
                    id={`sv-${product.id}`}
                    iconClass="fa fa-bell-slash"
                    size="sm"
                    tooltip="Unsubscribe"
                    onClick={() => handleUnsubscribe(subscription?.id)}
                  />
                ) : (
                  <IconButton
                    id={`sv-${product.id}`}
                    iconClass="fa fa-bell"
                    size="sm"
                    tooltip="Subscribe"
                    onClick={() =>
                      handleSubscribe(selectedVendor, product.name)
                    }
                    // onClick={() =>
                    //   subscribeProduct(selectedVendor, product.name).then((result) => {
                    //     result === true
                    //       ? showSuccessToast("Subscription Successful")
                    //       : showFailureToast("Failed to subscribe");
                    //   })
                    // }
                  />
                )}
              </td>
            </tr>
          );
        })
      ) : (
        <tr>
          <td colSpan={3}>
            {selectedVendor ? (
              <NoRecordFound />
            ) : (
              <div className="container-fluid h-100 text-center align-middle mt-5">
                <h6>
                  <i className="fa fa-exclamation-triangle fa-2x align-middle"></i>
                  <span className="align-middle p-2">
                    Select a vendor to view respective products.
                  </span>
                </h6>
              </div>
            )}
          </td>
        </tr>
      )}
    </>
  );
};

export default ProductsListing;
